module.exports = __webpack_public_path__ + "static/media/corpu_doc4.5adc1f6a.jpg";